import { useState } from 'react';
import { useAppForm } from 'shared/UI/UIKit/Form';
import { createBellSchedule, type BellSchedule } from 'services/api';

interface UseBellScheduleCopyProps {
  bellSchedule: BellSchedule;
  refreshTable: () => void;
}

export const useBellScheduleCopy = ({ bellSchedule, refreshTable }: UseBellScheduleCopyProps) => {
  const [modalVisible, setModalVisible] = useState(false);

  const [form] = useAppForm<BellSchedule>();

  const showModal = () => {
    setModalVisible(true);
    form.setFieldsValue(bellSchedule);
  };

  const hideModal = () => {
    setModalVisible(false);
  };

  const onSubmit = async () => {
    await form.validateFields().then(async (values) => {
      await createBellSchedule(values).then(() => {
        hideModal();
        refreshTable();
      });
    });
  };

  return {
    state: {
      modalVisible,
      form,
    },
    methods: {
      showModal,
      hideModal,
      onSubmit,
    },
  };
};
